import styled from 'styled-components';

import { Box, Icon, Button as ButtonYoga, Text } from '@gympass/yoga';
import { Check, AlertTriangle } from '@gympass/yoga-icons';

export const DocDownloadInfoItemIcon = styled(Icon).attrs({
  as: Check,
  size: 'large',
})`
  fill: ${props => props.theme.yoga.colors.medium};
  width: ${props => props.theme.yoga.spacing.large}px;
  height: ${props => props.theme.yoga.spacing.large}px;
  vertical-align: middle;
  margin-right: ${props => props.theme.yoga.spacing.xxsmall}px;
`;

export const DocDownloadInfoItem = styled(Box).attrs({
  as: 'li',
  py: '1',
  px: '7',
})`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  &:nth-child(odd) {
    background-color: ${props => props.theme.yoga.colors.elements.disabledRow};
    border-radius: ${props => props.theme.yoga.radii.xsmall}px;
  }
`;

export const DocDownloadButtonBack = styled(ButtonYoga.Text)`
  margin-right: ${props => props.theme.yoga.spacing.xxsmall}px;
`;

export const DocDownloadFormLegendHighlight = styled.span<{ href?: string }>`
  color: ${props => props.theme.yoga.colors[props.href ? 'primary' : 'medium']};
  font-weight: ${props => props.theme.yoga.fontWeights.bold};

  &:not(:hover) {
    text-decoration: ${props => props.href && 'underline'};
  }
`;

export const DocDownloadFormLegendIcon = styled(Icon).attrs({
  as: AlertTriangle,
})`
  flex-shrink: ${props => props.theme.yoga.spacing.zero};
  margin-right: ${props => props.theme.yoga.spacing.xsmall}px;
  align-self: center;
  width: ${props => props.theme.yoga.spacing.medium}px;
  height: ${props => props.theme.yoga.spacing.medium}px;
`;

export const DocDownloadContainer = styled.div`
  max-width: 520px;
`;

export const DischargeInfo = styled(Text.H5)`
  max-width: 520px;
  padding-bottom: ${props => props.theme.yoga.spacing.xxsmall}px;
`;
